<template>
  <UploadSuppliers
    :include-back-button="true"
    @back="$router.go(-1)"
    @uploaded-suppliers="getUploadedSuppliers"
  ></UploadSuppliers>
</template>

<script setup lang="ts">
import UploadSuppliers from "@/views/upload-suppliers/UploadSuppliers.vue";
import { useSuppliersStore } from "@/stores/suppliersStore";
import { useSnackBarStore } from "@/stores/snackBarStore";
import { onBeforeMount } from "vue";
import { useSelectedQuestionnaire } from "@/stores/selectedQuestionnare";
import { RouterPath } from "@/models/enum/routerPath";
import { useRouter } from "vue-router";

const suppliersStore = useSuppliersStore();
const snackBarStore = useSnackBarStore();
const selectedQuestionnaireStore = useSelectedQuestionnaire();
const router = useRouter();

onBeforeMount(() => {
  selectedQuestionnaireStore.progress = 2;
});
async function getUploadedSuppliers() {
  try {
    await suppliersStore.setSupplierList();
    router.push(RouterPath.ForwardQuestionnaire);
  } catch (error: any) {
    snackBarStore.showError(error.message);
  }
}
</script>
